import { useState } from 'react';
import loadable from '@loadable/component';

import { useUserAgent } from '@simplywallst/hooks/useUserAgent';

import { useIsMobileScreen } from '@/hooks/useMedia';

import type { ManualPortfolioState } from '../CreateManualPortfolio';
import type { PortfolioToUpdate } from '../../context/ManualPortfolioContext';

const HoldingsActionSheet = loadable(
  () => import('../Overlays/HoldingsActionSheet'),
  {
    resolveComponent: (c) => c.HoldingsActionSheet,
  }
);

const HoldingsModal = loadable(() => import('../Overlays/HoldingsModal'), {
  resolveComponent: (c) => c.HoldingsModal,
});

export const UpdateManualPortfolio = ({
  initialData,
  onClose,
}: {
  initialData: PortfolioToUpdate;
  onClose: () => void;
}) => {
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  const [manualPortfolioState, setManualPortfolioState] =
    useState<ManualPortfolioState>('edit');

  const [portfolioId, setPortfolioId] = useState<
    PortfolioToUpdate['portfolioId'] | null
  >(initialData.portfolioId);

  return isMobileScreen ? (
    <HoldingsModal
      initialData={initialData}
      portfolioId={portfolioId}
      setPortfolioId={setPortfolioId}
      manualPortfolioState={manualPortfolioState}
      setManualPortfolioState={setManualPortfolioState}
      onClose={onClose}
    />
  ) : (
    <HoldingsActionSheet
      initialData={initialData}
      portfolioId={portfolioId}
      setPortfolioId={setPortfolioId}
      manualPortfolioState={manualPortfolioState}
      setManualPortfolioState={setManualPortfolioState}
      onClose={onClose}
    />
  );
};
